import axios from "axios";
import {getAccessToken, refreshAccessToken, setAccessToken, setRefreshToken} from "./api-user-service";

const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL + "/api/pages-config",
    headers: {
        "Content-Type": "application/json",
    },
});


instance.interceptors.request.use(
    (config: any) => {
        const token = getAccessToken();
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (err.response) {
            // Validation failed, ...
            if (err.response.status === 400 && err.response.data) {
                return Promise.reject(err.response.data);
            }
            // Access Token was expired
            if (
                err.response.status === 401 &&
                !originalConfig._retry &&
                getAccessToken() != null
            ) {
                originalConfig._retry = true;
                try {
                    const rs = await refreshAccessToken();
                    const { accessToken, refreshToken } = rs.data;
                    setRefreshToken(refreshToken);
                    setAccessToken(accessToken);
                    instance.defaults.headers.common["Authorization"] =
                        "Bearer " + accessToken;
                    return instance(originalConfig);
                } catch (_error: any) {
                    if (_error.response && _error.response.data) {
                        return Promise.reject(_error.response.data);
                    }
                    return Promise.reject(_error);
                }
            }
            if (err.response.status === 403 && err.response.data) {
                return Promise.reject(err.response.data);
            }
            if (err.response.status === 404) {
                if (axios.isAxiosError(err)) {
                    return Promise.reject(err.response.data);
                }
                return;
            }
        }
        return Promise.reject(err);
    }
);

const responseBody: any = (response: any) => response.data;

const request = {
    get: (url: string) => instance.get(url).then().then(responseBody),
    post: (url: string, body?: any) =>
        instance.post(url, body).then().then(responseBody),
};

const PageConfig = {
    GetMainPageText: () => request.get("/get-main-page-text"),
    UpdateMainPageText: (text: string) => request.post("/update-main-page-text", { text: text }),
};

export async function GetMainPageText() {
    const data = await PageConfig.GetMainPageText()
        .then((response) => {
            return { response };
        })
        .catch((error) => {
            return error.response;
        });
    return data;
}

export async function UpdateMainPageText(text: string) {
    const data = await PageConfig.UpdateMainPageText(text);
    return data;
}